import React, { SyntheticEvent, useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setAuth } from "../Components/Redux/authSlice";
import { Link } from "react-router-dom";
import { FaEnvelope, FaArrowLeft, FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

// Function to get cookie value by name
function getCookie({ name }: { name: string }): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
    return null;
}

export const Forgot = () => {
    const [email, setEmail] = useState("");
    const [notify, setNotify] = useState({
        show: false,
        error: false,
        message: "",
    });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = getCookie({ name: "token" });
                if (!token) {
                    dispatch(setAuth(false));
                    return;
                }
                axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
                await axios.get("/users/user");
                dispatch(setAuth(true));
            } catch {
                dispatch(setAuth(false));
            }
        };
        fetchData();
    }, [dispatch]);

    const submit = async (e: SyntheticEvent) => {
        e.preventDefault();
        setLoading(true);
        setNotify({ show: false, error: false, message: "" });

        try {
            await axios.post("/users/forgot", { email });
            setNotify({
                show: true,
                error: false,
                message: "Link-ga dib-u-hagaajinta waa la diray! Fadlan fiiri email-kaaga.",
            });
            setEmail("");
        } catch {
            setNotify({
                show: true,
                error: true,
                message: "Waa la waayay in la diro link-ga. Fadlan isku day mar kale.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
                <div className="gradient-orb orb-3"></div>
            </div>

            <div className="auth-content">
                <div className="forgot-card">
                    <div className="forgot-header">
                        <div className="icon-container">
                            <FaEnvelope size={40} />
                        </div>
                        <h2 className="forgot-title">Hilmaamtay Lambarka Sirta?</h2>
                        <p className="forgot-subtitle">
                            Ha walwalin! Geli ciwaanka email-kaaga waxaan kuu soo diri doonaa link aad dib ugu hagaajisato lambarkaaga sirta ah.
                        </p>
                    </div>

                    {notify.show && (
                        <div className={`auth-alert ${notify.error ? 'error' : 'success'}`}>
                            <span className="alert-icon">
                                {notify.error ? <FaExclamationCircle /> : <FaCheckCircle />}
                            </span>
                            <span>{notify.message}</span>
                        </div>
                    )}

                    <form onSubmit={submit} className="forgot-form">
                        <div className="form-group">
                            <label htmlFor="email" className="form-label">Ciwaanka Email-ka</label>
                            <div className="input-wrapper">
                                <FaEnvelope className="input-icon" />
                                <input
                                    type="email"
                                    id="email"
                                    className="form-input"
                                    placeholder="Geli email-kaaga"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    disabled={loading}
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="auth-button"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner"></span>
                                    <span>Dirayaa...</span>
                                </>
                            ) : (
                                'Dir Link-ga Dib-u-hagaajinta'
                            )}
                        </button>

                        <Link to="/login" className="back-link">
                            <FaArrowLeft />
                            <span>Ku laabo Bogga Gelitaanka</span>
                        </Link>
                    </form>
                </div>
            </div>

            <style>{`
                .auth-container {
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    position: relative;
                    overflow: hidden;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                }

                .auth-background {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    overflow: hidden;
                    z-index: 0;
                }

                .gradient-orb {
                    position: absolute;
                    border-radius: 50%;
                    filter: blur(80px);
                    opacity: 0.6;
                    animation: float 20s ease-in-out infinite;
                }

                .orb-1 {
                    width: 500px;
                    height: 500px;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    top: -250px;
                    left: -250px;
                }

                .orb-2 {
                    width: 400px;
                    height: 400px;
                    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
                    bottom: -200px;
                    right: -200px;
                    animation-delay: 5s;
                }

                .orb-3 {
                    width: 350px;
                    height: 350px;
                    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    animation-delay: 10s;
                }

                @keyframes float {
                    0%, 100% { transform: translate(0, 0) scale(1); }
                    25% { transform: translate(30px, -30px) scale(1.1); }
                    50% { transform: translate(-20px, 20px) scale(0.9); }
                    75% { transform: translate(20px, 30px) scale(1.05); }
                }

                .auth-content {
                    position: relative;
                    z-index: 1;
                    width: 100%;
                    max-width: 480px;
                }

                .forgot-card {
                    background: rgba(255, 255, 255, 0.95);
                    backdrop-filter: blur(20px);
                    border-radius: 24px;
                    padding: 48px;
                    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
                    animation: slideUp 0.6s ease-out;
                }

                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .forgot-header {
                    text-align: center;
                    margin-bottom: 32px;
                }

                .icon-container {
                    width: 80px;
                    height: 80px;
                    margin: 0 auto 24px;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
                }

                .forgot-title {
                    font-size: 28px;
                    font-weight: 700;
                    color: #1a202c;
                    margin: 0 0 12px 0;
                    letter-spacing: -0.5px;
                }

                .forgot-subtitle {
                    font-size: 15px;
                    color: #718096;
                    margin: 0;
                    line-height: 1.6;
                }

                .auth-alert {
                    padding: 14px 16px;
                    border-radius: 12px;
                    margin-bottom: 24px;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    font-size: 14px;
                    animation: slideDown 0.4s ease-out;
                }

                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .auth-alert.error {
                    background: #fee;
                    color: #c53030;
                    border: 1px solid #fc8181;
                }

                .auth-alert.success {
                    background: #d4edda;
                    color: #155724;
                    border: 1px solid #c3e6cb;
                }

                .alert-icon {
                    font-size: 18px;
                    display: flex;
                }

                .forgot-form {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                }

                .form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                }

                .form-label {
                    font-size: 14px;
                    font-weight: 600;
                    color: #2d3748;
                }

                .input-wrapper {
                    position: relative;
                    display: flex;
                    align-items: center;
                }

                .input-icon {
                    position: absolute;
                    left: 16px;
                    color: #a0aec0;
                    font-size: 16px;
                    pointer-events: none;
                }

                .form-input {
                    width: 100%;
                    padding: 14px 16px 14px 48px;
                    border: 2px solid #e2e8f0;
                    border-radius: 12px;
                    font-size: 15px;
                    transition: all 0.3s ease;
                    background: white;
                }

                .form-input:focus {
                    outline: none;
                    border-color: #667eea;
                    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
                }

                .form-input:disabled {
                    background: #f7fafc;
                    cursor: not-allowed;
                }

                .auth-button {
                    width: 100%;
                    padding: 14px 24px;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: white;
                    border: none;
                    border-radius: 12px;
                    font-size: 16px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
                }

                .auth-button:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
                }

                .auth-button:active:not(:disabled) {
                    transform: translateY(0);
                }

                .auth-button:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }

                .spinner {
                    width: 16px;
                    height: 16px;
                    border: 2px solid rgba(255, 255, 255, 0.3);
                    border-top-color: white;
                    border-radius: 50%;
                    animation: spin 0.6s linear infinite;
                }

                @keyframes spin {
                    to { transform: rotate(360deg); }
                }

                .back-link {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    color: #667eea;
                    font-size: 14px;
                    font-weight: 500;
                    text-decoration: none;
                    transition: all 0.2s;
                }

                .back-link:hover {
                    color: #764ba2;
                    gap: 12px;
                }

                @media (max-width: 640px) {
                    .forgot-card {
                        padding: 32px 24px;
                    }

                    .forgot-title {
                        font-size: 24px;
                    }

                    .icon-container {
                        width: 64px;
                        height: 64px;
                    }
                }
            `}</style>
        </div>
    );
};
